import { useEffect } from 'react';
import { fetchAdmin, toErrorMessage } from '../../admin/api';
import { AdminDataTable } from '../../sections/admin/shared';
import { AdminRouteLayout, RequestState, useAsyncState } from './AdminRoutePageShared';

export default function ServiceReportsIncidentsPage() {
  const overview = useAsyncState(null);

  useEffect(() => {
    const load = async () => {
      overview.setLoading();
      try {
        const response = await fetchAdmin('/services/incidents');
        overview.setData(response);
      } catch (error) {
        overview.setError(toErrorMessage(error));
      }
    };

    load();
  }, []);

  return (
    <AdminRouteLayout title="Incidents" breadcrumbTitle="Service Reports">
      <RequestState loading={overview.state.loading} error={overview.state.error}>
        <AdminDataTable
          title="Incidents"
          description="Provider incidents returned from the incidents endpoint."
          columns={[
            { field: 'provider', headerName: 'Provider' },
            { field: 'status', headerName: 'Status' },
            { field: 'severity', headerName: 'Severity' },
            { field: 'summary', headerName: 'Summary' },
          ]}
          rows={(overview.state.data?.incidents || []).map((row) => ({
            id: row.id,
            provider: row.provider,
            status: row.status,
            severity: row.severity,
            summary: row.summary,
          }))}
          emptyTitle="No incidents"
          emptyDescription="The incidents endpoint returned no incident rows."
        />
      </RequestState>
    </AdminRouteLayout>
  );
}
